import { useContext, useState } from "react";
import { Fetch } from "../../services/api";
import { notify } from "../../utils/utils";
import { UserContext } from "../../context/provider/UserProvider";
const urlSeguimiento = process.env.REACT_APP_XPROJECT_API + "/Tracing";
export const useSeguimientos = () => {
    const { stateUser } = useContext(UserContext);
    const seguimientoTicketDefault = {
        codTicket: 0,
        codEstado: 0,
        codTicketSeguimiento: 0,
        descripcion: "",
        fechaCreacion: "",
        nomEstado: "",
        nomUsuarioCreacion: ""
    }

    const [ nuevoSeguimientoTicket, setNuevoSeguimientoTicket ] = useState(seguimientoTicketDefault);
    const [ seguimientosTicket, setSeguimientosTicket] = useState([]);

    const listarSeguimientoTicket = async (codTicket) => {
        try{
            const response = await Fetch({
                url: urlSeguimiento + '?' +  new URLSearchParams({
                    CodTicket: codTicket
                }),
                method: 'GET'
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setSeguimientosTicket(response.isValid ? response.content : []) 
        }
        catch(e){
            setSeguimientosTicket([]);
            notify('Ocurrió un error en el servicio', 'error');
            console.log('Error al listar seguimiento por ticket: ',e);
        }
    }

    
    const editarValorNuevoSeguimiento = (key, value) => {
        setNuevoSeguimientoTicket(seguimientoTicket => {
            return {
                ...seguimientoTicket,
                [key]: value
            }
        });
    }

    const editarValorSeguimiento = (index, key, value) => {
        setSeguimientosTicket((seguimientos) =>
            seguimientos.map((seg, i) =>
                i === index
                    ? { ...seg, [key]: value } // Actualiza solo la tarea específica
                    : seg // Mantén las demás tareas sin cambios
            )
        );
    }

    const registrarSeguimientoPorTicket = async (indice) => {
        try{
            const esGuardar = indice === undefined ? true : false;
            const response = await Fetch({
                url: urlSeguimiento,
                method: esGuardar ? 'POST' : 'PUT',
                body: JSON.stringify({
                    CodUsuarioAccion: stateUser.codUsuario,
                    ...(esGuardar ?
                        { 
                            CodTicket: nuevoSeguimientoTicket.codTicket,
                            Descripcion: nuevoSeguimientoTicket.descripcion,
                        }
                        :
                        {
                            CodTicketSeguimiento: seguimientosTicket[indice].codTicketSeguimiento,
                            Descripcion: seguimientosTicket[indice].descripcion,
                        }
                    ),
                })
            });
            notify(response.isValid ? response.content : response.exceptions[0].description, (response.isValid ? 'success' : 'error'));
            return response.isValid;
        }
        catch(e){
            console.log('Error al registrar seguimiento: ',e)
            notify('Ocurrió un error en el servicio','error');
            return false;
        }
    }

    const eliminarSeguimiento = async (codTicketSeguimiento) => {
        try{
            const response = await Fetch({
                url: urlSeguimiento,
                method: 'DELETE',
                body: JSON.stringify({
                    CodUsuarioAccion: stateUser.codUsuario,
                    CodTicketSeguimiento: codTicketSeguimiento
                })
            })
            notify((response.isValid ? response.content : response.exceptions[0].description ) , response.isValid ? 'success' : 'error');
            return response.isValid
        }
        catch(e){
            notify('Ocurrió un error en el servicio', 'error');
            console.log('Error al listar seguimiento por ticket: ',e);
        }
    }

    return{
        seguimientosTicket,
        listarSeguimientoTicket,
        nuevoSeguimientoTicket,
        editarValorNuevoSeguimiento,
        registrarSeguimientoPorTicket,
        editarValorSeguimiento,
        eliminarSeguimiento
    }
}